import notifyReducer from 'react-redux-notify';
export const notifications = notifyReducer